import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

const MedataContext = createContext();



function MedataProvider({ children }) {

  const [datasets, setDatasets] = useState(null);
  const [datasetsL, setDatasetsL] = useState(0);
  const [themes, setThemes] = useState([]);
  const [publishersL, setPublishersL] = useState(0);
  const [items, setItems] = useState([]);
  const [fDatasets, setFDatasets] = useState([]);
  const [boardsLength, setBoardsLength] = useState(0);
  const [downloads, setDownloads] = useState(0);
  const [visits, setVisits] = useState(0);
  const [datasetDonwloads,setDatasetDonwloads] = useState(0);

  useEffect(() => {
    async function fetchAllData() {
      try {
        // Contadores y destacados desde el endpoint ligero /api/stats (COUNT/SUM
        // directos, ~ms). Antes esto se obtenía descargando el catálogo completo
        // de DKAN (/metastore/schemas/dataset/items) y /search, que con el
        // volumen actual se cuelgan (timeout > 300 s -> 504) y hacían lentísima
        // CADA carga de página. Los temas siguen viniendo de theme/items, que sí
        // responde rápido.
        // /api/stats es una ruta absoluta del módulo medata_stats (NO lleva el
        // prefijo /api/1 de DKAN). theme/items sí es de DKAN, con su prefijo.
        const [statsRes, themesRes] = await Promise.all([
          axios.get(`/api/stats`),
          axios.get(`${process.env.REACT_APP_ROOT_URL}/metastore/schemas/theme/items`),
        ]);

        const stats = statsRes.data || {};
        setDatasetsL(stats.datasets || 0);
        setPublishersL(stats.publishers || 0);
        setBoardsLength(stats.tableros || 0);
        setVisits(stats.visitas || 0);
        setDownloads(stats.descargas || 0);
        setFDatasets(Array.isArray(stats.featured) ? stats.featured : []);

        setThemes(themesRes.data);

        // Marca la carga como completada (evita re-disparos).
        setDatasets(stats);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    if (datasets === null) {
      fetchAllData();
    }
  }, [datasets]);

  useEffect(() => {
    setItems(
      themes.map((x) => {
        let item = {
          identifier: x.identifier,
          ref: `search/?theme=${x.data}`,
          title: x.data,
        };
        return item;
      })
    );
  }, [themes]);

  return (
    <MedataContext.Provider value={{
      datasets,
      setDatasets,
      datasetsL,
      setDatasetsL,
      publishersL,
      setPublishersL,
      items,
      setItems,
      fDatasets,
      setFDatasets,
      boardsLength,
      setBoardsLength,
      downloads,
      visits,
      datasetDonwloads,
      setDatasetDonwloads
    }}>
      {children}
    </MedataContext.Provider>
  );
}

export { MedataContext, MedataProvider };
